<app-card-widget title="Comments (v2)" *ngIf="invoice$ | async">
<ng-container *ngIf="data$ | async as data">

  <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex" (selectedIndexChange)="tabIndexChanged($event)">
    <mat-tab [disabled]="added || edited">
      <ng-template matTabLabel>
        <span [matBadgeHidden]="data.tabs[0].length === 0" [matBadge]="data.tabs[0].length.toString()" matBadgeOverlap="false">PRIORITY</span>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="added || edited">
      <ng-template matTabLabel>
        <span [matBadgeHidden]="data.tabs[1].length === 0" [matBadge]="data.tabs[1].length.toString()" matBadgeOverlap="false">CLIENT</span>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="added || edited">
      <ng-template matTabLabel>
        <span [matBadgeHidden]="data.tabs[2].length === 0" [matBadge]="data.tabs[2].length.toString()" matBadgeOverlap="false">END CUST</span>
      </ng-template>
    </mat-tab>
    <mat-tab [disabled]="added || edited">
      <ng-template matTabLabel>
        <span [matBadgeHidden]="data.tabs[3].length === 0" [matBadge]="data.tabs[3].length.toString()" matBadgeOverlap="false">INVOICE</span>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <form [formGroup]="form" id="comments-v2-form" (ngSubmit)="save()" style="margin-top: 16px" novalidate>

    <div class="card-section-container">

      <div class="card-section">
        <mat-nav-list [class.list-item-autoheight]="!selectedItem && !added">
          <mat-list-item *ngFor="let item of data.tabs[selectedIndex]" (click)="itemClicked(item)" [class.mat-elevation-z2]="item === selectedItem">
            <mat-icon matListIcon *ngIf="!item.priority">comment</mat-icon>
            <mat-icon matListIcon matBadge="!" matBadgePosition="above after" *ngIf="item.priority">comment</mat-icon>
            <h3 matLine>{{item.body}}</h3>
            <span matLine>{{item.user?.name}}</span>
            <div class="list-item-timestamp">{{item.created_at | date:'short'}}</div>
          </mat-list-item>
        </mat-nav-list>
      </div>

      <div class="card-section" *ngIf="selectedItem || added">

        <app-text label="Comment" *ngIf="!added && !edited"><span>{{selectedItem?.body}}</span></app-text>

        <mat-form-field *ngIf="added || edited">
          <textarea matInput placeholder="Comment" formControlName="body" rows="18"></textarea>
        </mat-form-field>

        <app-text label="Priority" *ngIf="!added && !edited">
          <span *ngIf="!selectedItem?.priority">No</span>
          <span *ngIf="selectedItem?.priority">Yes</span>
        </app-text>

        <mat-checkbox *ngIf="added || edited" formControlName="priority">Priority</mat-checkbox>

        <app-text label="User" *ngIf="!added && !edited">{{selectedItem?.user?.name}}</app-text>

        <app-text label="Created" *ngIf="!added && !edited">{{selectedItem?.created_at | date:'medium'}}</app-text>

      </div>

    </div>

  </form>

  <mat-card-actions align="end">
    <button type="button" mat-button *ngIf="!added && !edited && selectedIndex !== 0" [disabled]="!isAddable()" (click)="add()">Add</button>
    <button type="button" mat-button *ngIf="!added && !edited" [disabled]="locked || !selectedItem" (click)="edit()">Edit</button>
    <button type="button" mat-button *ngIf="edited" [disabled]="saving" (click)="remove()">Remove</button>
    <button type="submit" mat-button *ngIf="added || edited" [disabled]="!form.valid || saving" form="comments-v2-form">Save</button>
    <button type="reset" mat-button *ngIf="added || edited" (click)="revert()">Cancel</button>
  </mat-card-actions>

</ng-container>
</app-card-widget>
